import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Backdrop, Grow, Modal } from '@material-ui/core';

const descripcion = (movil) => {
	const marcaModelo = [movil.marca, movil.modelo].filter(Boolean).join(' ');
	return marcaModelo ? movil.dominio + ' — ' + marcaModelo : movil.dominio;
};

const SolicitudSeleccionarMovilModal = ({ solicitud, onSeleccionar, onClose }) => {
	const intl = useIntl();
	const principal = solicitud.entidad;
	const [movilId, setMovilId] = useState(principal.id);

	const opciones = [principal].concat(solicitud.activosVinculados);
	const elegido = opciones.find((movil) => movil.id === movilId);

	return (
		<Modal open onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
			<Grow in>
				<div tabIndex="-1" role="dialog">
					<div className="modal-lg modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white mb-0">
									<i className="la la-car align-middle icon-modal-title"></i>{' '}
									<FormattedMessage
										id="solicitudSeleccionarMovilModal.titulo"
										defaultMessage="Liberar solicitud {numero}: seleccionar móvil"
										values={{ numero: solicitud.numero }}
									/>
								</h4>
								<button type="button" className="close" aria-label="Close" onClick={onClose}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								<div className="card pull-up mb-0">
									<div className="card-content">
										<div className="card-body">
											<p>
												<FormattedMessage
													id="solicitudSeleccionarMovilModal.instruccion"
													defaultMessage="El móvil {dominio} tiene activos vinculados. Seleccione para cuál se genera el correctivo:"
													values={{ dominio: principal.dominio }}
												/>
											</p>
											{opciones.map((movil) => (
												<div key={movil.id} className="form-check mb-1">
													<input
														type="radio"
														className="form-check-input"
														id={'movilLiberar' + movil.id}
														name="movilLiberar"
														checked={movilId === movil.id}
														onChange={() => setMovilId(movil.id)}
													/>
													<label className="form-check-label" htmlFor={'movilLiberar' + movil.id}>
														{descripcion(movil)}{' '}
														<span className="text-muted">
															{movil.id === principal.id
																? intl.formatMessage({ id: 'solicitudSeleccionarMovilModal.principal', defaultMessage: '(móvil de la solicitud)' })
																: intl.formatMessage({ id: 'solicitudSeleccionarMovilModal.vinculado', defaultMessage: '(activo vinculado)' })}
														</span>
													</label>
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-primary mr-1" onClick={() => onSeleccionar(elegido)}>
									<i className="fa fa-check-circle"></i>{' '}
									<FormattedMessage id="solicitudSeleccionarMovilModal.continuar" defaultMessage="Continuar" />
								</button>
								<button type="button" className="btn btn-danger" onClick={onClose}>
									<i className="fa fa-times-circle"></i>{' '}
									<FormattedMessage id="solicitudSeleccionarMovilModal.cancelar" defaultMessage="Cancelar" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default SolicitudSeleccionarMovilModal;
